import "../Styles/MakeUp.css";
import hearts from "../../../public/wardrobe/hearts.jpg";
import Container from "./Container";
import SubmitButton from "./SubmitButton";
import Lipgloss from "../../../public/graphics/huulikiilto.png";
import LipLines from "../../../public/graphics/huultenrajaus.png";
import Dialogue from "../Dialogue";
import { useEffect, useRef, useState } from "react";
import ImgRadioButton from "./ImgRadioButton";
import "../Styles/EndScreen.css";

/**
 * @typedef {import("./Endscreen.d.ts").EndScreenProps} Props
 */
const texts = {
  endScreenText:
    "Onneksi olkoon, pääsit bileisiin! Ilta sujui lopulta rauhallisesti: bestiksesi Venlan vanhemmat kävivät aika ajoin tarkistamassa, ettei meno yltynyt liian villiksi.",
  vaateOnnistunutLahjaMukanaHuulikiiltoEi:
    "Näytit upealta valitsemassasi asussa ja ihastuksesi Jake katseli sinua sillä silmällä koko illan. Bestiksesi Venla oli aivan myyty lahjasta, jonka hänelle annoit. Bileet kruunasi se, kun vaihdoitte ujon pusun Jaken kanssa. Ilta oli kaikin puolin täydellinen.",
  vaateOnnistunutLahjaOikeaHuulikiilto:
    "Näytit upealta valitsemassasi asussa ja ihastuksesi Jake katseli sinua sillä silmällä koko illan. Bestiksesi Venla oli aivan myyty lahjasta, jonka hänelle annoit. Koko illan kruunasi, kun Jake pussasi sinua ujosti. Harmi kyllä ensisuudelma oli aika tahmea huulikiillon takia.",
  vaateOnnistunutLahjaHuono:
    "Näytit upealta valitsemassasi asussa ja ihastuksesi Jake katseli sinua sillä silmällä koko illan. Bestiksesi Venla ei kuitenkaan ollut erityisen innoissaan antamastasi lahjasta ja tuntui välttelevän sinua bileissä. Onneksi Jake huomasi tilanteen ja lohdutti sinua.",
  vaateOnnistunutLahjaPuuttuuHuulikiilto:
    "Näytit upealta ja ihastuksesi Jake katseli sinua sillä silmällä koko illan. Et kuitenkaan muistanut tuoda bestiksellesi Venlalle lahjaa! Harmillisesti iltasi kului loukkaantuneen Venlan lepyttelyssä, etkä ehtinyt vaihtaa enempää kuin katseita Jaken kanssa.",
  vaateOkLahjaOikea:
    "Asuvalintasi ei herättänyt huomiota hyvässä tai pahassa, mutta ainakaan et nolannut itseäsi. Bestiksesi Venla oli aivan myyty lahjasta, jonka hänelle annoit. Juttelit ihastuksesi Jaken kanssa koulusta, mutta et päässyt tekemään lähempää tuttavuutta. Ehkä harkitumpi asu olisi tie hänen sydämeensä?",
  vaateOkLahjaHuono:
    "Asuvalintasi ei herättänyt huomiota hyvässä tai pahassa, mutta ainakaan et nolannut itseäsi. Bestiksesi Venla ei kuitenkaan ollut erityisen innoissaan antamastasi lahjasta ja tuntui vältävän sinua bileissä. Juttelit ihastuksesi Jaken kanssa koulusta, mutta et päässyt tekemään lähempää tuttavuutta. Ehkä olisit voinut harkita tekojasi tarkemmin?",
  vaateOkLahjaPuuttuu:
    "Asuvalintasi ei herättänyt huomiota hyvässä tai pahassa, mutta ainakaan et nolannut itseäsi. Et kuitenkaan muistanut tuoda bestiksellesi Venlalle lahjaa! Harmillisesti iltasi kului loukkaantuneen Venlan lepyttelyssä, eikä ihastuksesi Jake vaikuttanut kiinnostuneelta. Olisiko illan voinut pelastaa eri valinnoilla?",
  vaateHuonoLahjaOikea:
    "Vaatevalintasi ei nyt osunut nappiin. Bestiksesi Venla ja hänen uusi ystävänsä Emilia pitivät yhteensopivia asuja ja olivat juhlien keskipisteenä koko illan. Jake ei tuntunut edes huomaavan olemassaoloasi, mutta Venla kuitenkin rakasti antamaasi lahjaa. Ehkä ystävät ovat poikia tärkeämpiä?",
  vaateHuonoLahjaHuono:
    "Vaatevalintasi ei nyt osunut nappiin. Bestiksesi Venla ja hänen uusi ystävänsä Emilia pitivät yhteensopivia asuja ja olivat juhlien keskipisteenä koko illan. Jake ei tuntunut edes huomaavan olemassaoloasi, eikä Venla pitänyt antamastasi lahjasta. Ehkä on aika arvioida valintojasi uudelleen?",
  vaateHuonoLahjaPuuttuu:
    "Vaatevalintasi ei nyt osunut nappiin. Bestiksesi Venla ja hänen uusi ystävänsä Emilia pitivät yhteensopivia asuja ja olivat juhlien keskipisteenä koko illan. Jake ei tuntunut edes huomaavan olemassaoloasi. Venla odotti kovasti saavansa sinulta lahjan, mutta ilmestyit tyhjin käsin. Tämä ilta oli täydellinen farssi! Olisitko voinut tehdä jotain toisin?",
  tryAgainButton: "Testaa, miten ilta sujuu, jos teet eri valintoja!",
};

export const AdditionalModels = () => {
  
  return <div className="additional-models">
    <ul style={{ listStyleType: 'none' }}>
  <li><b>Messy bed 2.0</b> (with wall mounted backboard) by thethieme on Sketchfab</li>
  <li><b>Table Mirror</b> by rickmaolly on Sketchfab</li>
  <li>Computer from <b>Corner of bedroom</b> by Yuchao Wang on Sketchfab</li>
  <li><b>Desk</b> by Ridwan on Sketchfab</li>
  <li>All under CC BY 4.0</li>
</ul>
  </div>
}
/**
 * Props for the component.
 * @typedef {Object} EndScreenProps
 * @property {"puuttuu" | "ok" | "huono"} lahja - The lahja option.
 * @property {"onnistunut" | "ok" | "huono"} vaatteet - The vaatteet option.
 * @property {boolean} huulikiilto - The huulikiilto option.
 */

/**
 * MyComponent description
 * @typedef {import("./Endscreen.d.ts").EndScreenProps} Props
 * @param {Props} props - The component props.
 * @returns {JSX.Element} The rendered component.
 */
const DebugInformation = (props) => {
  return null;
  return <div className="additional-models">
    <p><strong>Debugs</strong></p>
    <p>Vaatteet {props.vaatteet} </p>
    <p>Lahja {props.lahja}</p>
    <p>Huulikiilto {props.huulikiilto ? "juu" : "ei"}</p>
    <p>textcode {props.textCode}</p>
  </div>
}



export const Authors = (props) => {
  return (
    <>

      <div className="authors-container">
        <ul className="authors">
          <li>
            <strong>Käsikirjoitus:</strong> Iida Putkonen, Annika Veteli
          </li>
          <li>
            <strong>Grafiikat:</strong> Annukka Palmén-Väisänen, Annika Veteli
          </li>
          <li>
            <strong>Toteutus:</strong> Annika Veteli, Antti Saarenpää
          </li>
          <li>
            <strong>Tuottaja:</strong> Marjo Harju, Miia Honkanen
          </li>
          <li style={{visibility: "hidden"}}>*</li>
          <li>Julkaistu 6.7.2023</li>
          <li>
           Yle Luovat sisällöt ja Media 
          </li>
        </ul>

      </div>

            <AdditionalModels />
    </>
  );
};


/**
 * Props for the component.
 * @typedef {Object} EndScreenProps
 * @property {"puuttuu" | "ok" | "huono"} lahja - The lahja option.
 * @property {"onnistunut" | "ok" | "huono"} vaatteet - The vaatteet option.
 * @property {boolean} huulikiilto - The huulikiilto option.
 */

/**
 * MyComponent description
 * @typedef {import("./Endscreen.d.ts").EndScreenProps} Props
 * @param {Props} props - The component props.
 * @returns {JSX.Element} The rendered component.
 */
const EndScreen = (props) => {
  const { vaatteet, huulikiilto, lahja } = props;
  const vaatteetOnnistunut = vaatteet === "onnistunut";
  const vaatteetOk = vaatteet === "ok";
  const vaatteetHuono = vaatteet === "huono";
  let textCode = "";

  const lahjaOk = lahja === "ok";
  const lahjaHuono = lahja === "huono";
  const lahjaPuuttuu = lahja === "puuttuu";

  let textToShow = "";
  switch (true) {
    case vaatteetOnnistunut && lahjaOk && !huulikiilto:
      textToShow = texts.vaateOnnistunutLahjaMukanaHuulikiiltoEi;
      textCode = "texts.vaateOnnistunutLahjaMukanaHuulikiiltoEi";
      break;
    case vaatteetOnnistunut && lahjaOk && huulikiilto:
      textToShow = texts.vaateOnnistunutLahjaOikeaHuulikiilto;
      textCode = "texts.vaateOnnistunutLahjaMukanaHuulikiilto"; 
      break;
    case vaatteetOnnistunut && lahjaHuono:
      textToShow = texts.vaateOnnistunutLahjaHuono;
      textCode = "texts.vaateOnnistunutLahjaHuono";
      break;
    case vaatteetOnnistunut && lahjaPuuttuu:
      textToShow = texts.vaateOnnistunutLahjaPuuttuuHuulikiilto;
      textCode = "texts.vaateOnnistunutLahjaPuuttuuHuulikiilto";
      break;
    case vaatteetOk && lahjaOk:
      textToShow = texts.vaateOkLahjaOikea;
      textCode= "texts.vaateOkLahjaOikea";
      break;
    case vaatteetOk && lahjaHuono:
      textToShow = texts.vaateOkLahjaHuono;
      textCode = "texts.vaateOkLahjaHuono";
      break;
    case vaatteetOk && lahjaPuuttuu:
      textToShow = texts.vaateOkLahjaPuuttuu;
      textCode = "texts.vaateOkLahjaPuuttuu";
      break;
    case vaatteetHuono && lahjaOk:
    textToShow = texts.vaateHuonoLahjaOikea;
    textCode = "texts.vaateHuonoLahjaOikea";
      break;
    case vaatteetHuono && lahjaHuono:
      textToShow = texts.vaateHuonoLahjaHuono;
      textCode = "texts.vaateHuonoLahjaHuono"
      break;
    case vaatteetHuono && lahjaPuuttuu:
      textToShow = texts.vaateHuonoLahjaPuuttuu;
      textCode = "texts.vaateHuonoLahjaPuuttuu"
      break;
    default:
      textToShow = "";
      break;
  }
  return (
    <>
      {props.visible && (
        <>
          <Container
            class={"end-view-container"}
            headerText={"Jesss!"}
          >
            <p
              style={{
                fontSize: "large",
                fontWeight: "bold",
                textTransform: "uppercase",
                letterSpacing: "1.4px",
                marginTop: "2em"
              }}
            >
              Pääsit bileisiin!
            </p>
            <div class="end-teksti">
            <p>{textToShow}</p>
            <p>Pelissä on kymmenen loppuratkaisua. Saatko unlockattua kaikki?</p>
            </div>
            <button className="submit-button" onClick={() => window.location.reload()}>
              Yritä uudelleen
            </button>
            <Authors />
            {false && <DebugInformation {...props} textCode={textCode}/>}
          </Container>
        </>
      )}
    </>
  );
};

export default EndScreen;
